<template>
  <div class="login-view">
    <div class="login-panel">

      <div class="login-panel-logo">
        <img src="../assets/viking-logo-black.svg" />
      </div>

      <div class="login-panel-text">
        
      </div>
      <form method="POST" :action="signInUrl">
        <input type="hidden" name="ReturnUrl" v-model="loginForm.returnUrl" />

        <div class="login-panel-form">
          <div class="field">
            <label class="label">Ins. nummer</label>
            <div class="control has-icons-left">
              <input class="input" type="text" name="email" v-model="loginForm.email" />
              <span class="icon is-small is-left">
                <font-awesome-icon icon="envelope"></font-awesome-icon>
              </span>
            </div>
          </div>

          <div class="field">
            <label class="label">Adgangskode</label>
            <div class="control has-icons-left">
              <input class="input" type="password" name="password" v-model="loginForm.password" />
              <span class="icon is-small is-left">
                <font-awesome-icon icon="lock"></font-awesome-icon>
              </span>
            </div>
          </div>
        </div>

        <div class="login-panel-controls">
          <button type="submit" class="button is-fullwidth is-primary">Log ind</button>
        </div>
      </form>

    </div>
  </div>
</template>

<script>
import { oidcSettings } from '../config/oidc';

const authority = oidcSettings.authority;
const api = "https://localhost:44310";

export default {
  name: 'login-view',
  data: () => ({
    loginForm: {
      email: '',
      password: '',
      returnUrl: (new URLSearchParams(window.location.search)).get('ReturnUrl'),
      rememberMe: false
    }
  }),
  async mounted() {
    if (localStorage.groupFilter) {
      localStorage.groupFilter = 'null';
    }

    if(localStorage.employeeFilter) {
      localStorage.employeeFilter = 'null';
    }

    if(localStorage.regionFilter) {
      localStorage.regionFilter = 'null';      
    }
  },
  computed: {
    signInUrl() {
      return `${authority}/api/authorization/login`;
    }
  }
}
</script>

<style lang="scss">
.login-view {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;

  .login-panel {
    flex: 1;
    display: flex;
    flex-flow: column;
    max-width: 400px;
    gap: 15px;

    .login-panel-controls {
      margin-top: 10px;
    }
  }
}
</style>
